import React from "react";
import { t } from 'i18next';
import { requestOpenNcpInquiry } from '../../helper/components/SupportButton';


const SUPPORT_EMAIL = 'ncp.itsupport@sktes.com';

export default function NeedHelpBox({ pId, signInFooter }) {

    const faqsUrl = pId ? `/faqs?pId=${pId}` : '/faqs';
    const onContactSupportClick = (e) => {
        e.preventDefault();
        requestOpenNcpInquiry();
    };
    return (
        <>
            <span>{t('TxtNeedHelp')}</span><br />
            <a className="lnk-btn" target="_blank" rel="noopener noreferrer" href={faqsUrl}>{t('FAQs.LabelFrequentlyAskedQuestions')}</a><br />
            {signInFooter ? (
                <a
                    className="lnk-btn"
                    href="#contact-support"
                    onClick={onContactSupportClick}
                >
                    {t('LabelContactSupport')}
                </a>
            ) : (
                <span>{t('TxtEmailUsAt')} <a className="lnk-btn" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a></span>
            )}
        </>
    );
}
